import { useEffect, useState } from 'react'

import { Text } from '@wartek-id/text-v1'
import { Button } from '@wartek-id/button-v1'
import {
  Dialog,
  DialogContent,
  DialogOverlay,
  DialogCloseButton,
} from '@wartek-id/dialog-v1'

import { getPangkatGolongan } from 'app/KinerjaPage/utils/pangkat'
import { mapJenjangName } from 'app/KinerjaPage/utils/jenjang'
import {
  DescriptionList,
  DescriptionListItem,
} from 'app/KinerjaShared/components/DescriptionList'

import type { KinerjaProfil } from 'types/kinerja'

import ImgAssessmentSubjectBook from 'assets/icons/img-assessment-subject-book.svg'

interface ConfirmDialogProps {
  profile: KinerjaProfil
  isOpen: boolean
  disabledConfirmButton?: boolean
  isLoading?: boolean
  onClose?: () => void
  onConfirm?: () => void
}

export default function ConfirmDialog({
  profile,
  isOpen,
  onClose = () => {},
  onConfirm = () => {},
  disabledConfirmButton = false,
  isLoading = false,
}: ConfirmDialogProps) {
  const [isDialogOpen, setIsDialogOpen] = useState(isOpen)

  useEffect(() => {
    setIsDialogOpen(isOpen)
  }, [isOpen])

  const handleDialogClose = () => {
    setIsDialogOpen(false)
    onClose()
  }

  const handleConfirm = () => {
    onConfirm()
  }

  return (
    <Dialog isOpen={isDialogOpen} onClose={onClose} size="sm">
      <DialogOverlay />
      <DialogContent aria-labelledby="confirm-dialog-title">
        <div className="inline-flex flex-col gap-4 pt-[60px] px-6">
          <ImgAssessmentSubjectBook width={84} height={84} />

          <Text variant="display-sm" id="confirm-dialog-title">
            Apakah data diri Anda sudah benar?
          </Text>

          <DescriptionList
            labelledById="confirm-dialog-title"
            className="space-y-2"
          >
            <DescriptionListItem label="Nama" value={profile.nama} />
            {profile.kategoriPegawai !== 'UNDEFINED' && (
              <DescriptionListItem label="NIP" value={profile.nip} />
            )}
            <DescriptionListItem
              label="Status Kepegawaian"
              value={profile.statusPegawai || '-'}
            />
            {profile.kategoriPegawai === 'PNS' && (
              <DescriptionListItem
                label="Pangkat, Golongan Ruang"
                value={getPangkatGolongan(profile.pangkatGolongan)}
              />
            )}
            {profile.kategoriPegawai !== 'UNDEFINED' && (
              <DescriptionListItem
                label="Jenjang Jabatan"
                value={mapJenjangName(profile.jenjang)}
              />
            )}
            <DescriptionListItem
              label="Satuan Pendidikan Induk"
              value={profile.satuanPendidikan}
            />
            {profile.timKinerja && (
              <DescriptionListItem
                label="Tim Kinerja"
                value={profile.timKinerja || '-'}
              />
            )}

            {profile.pejabatPenilaiKinerja && (
              <DescriptionListItem
                label="Pejabat Penilai Kinerja"
                value={profile.pejabatPenilaiKinerja || '-'}
              />
            )}
          </DescriptionList>

          <Text>
            Saat ini data hanya bisa diedit satu kali saja. Pastikan sesuai, ya.
          </Text>
        </div>
        <div className="flex p-6 mt-3 gap-5">
          <Button
            disabled={disabledConfirmButton}
            isLoading={isLoading}
            size="lg"
            onClick={handleConfirm}
          >
            Data sudah benar
          </Button>
          <Button size="lg" color="white" onClick={handleDialogClose}>
            Cek ulang
          </Button>
        </div>
        <DialogCloseButton />
      </DialogContent>
    </Dialog>
  )
}
